import { get } from 'lodash';

/**
 * @typedef LoginResult
 * @property {Boolean} success
 * @property {Number} statusCode
 * @property {Object} response
 * @property {String} apiCode
 * @property {{jwt: string, otpProvisioningUri: string}} [response]
 * @property {{ [path]: string, [name]: string, [query]: Object }} [redirect]
 */

/**
 * Returns a LoginResult from a successful login response.
 * @param {Object} response
 * @return {LoginResult}
 */
export function loginResultFromResponse(response) {
  return {
    success: true,
    statusCode: 200,
    response: response || {},
    apiCode: get(response, 'code', 'ok'),
    redirect: undefined,
  };
}

/**
 * Returns a LoginResult from a request error.
 * @param {Object} error
 * @return {LoginResult}
 */
export function loginResultFromError(error) {
  const response = error.response;
  return {
    success: false,
    statusCode: response.status,
    response: get(response, 'data.response', {}),
    apiCode: get(response, 'data.response.code', 'error'),
    redirect: undefined,
  };
}
